import React from "react";
import CorporateAccess from "../CorporateAccess";
import "./Login.css";

export default function Login() { return <CorporateAccess />; }
